import { render, staticRenderFns } from "./information_about_relationship.vue?vue&type=template&id=406e3d26&"
import script from "./information_about_relationship.vue?vue&type=script&lang=js&"
export * from "./information_about_relationship.vue?vue&type=script&lang=js&"
import style0 from "./information_about_relationship.vue?vue&type=style&index=0&id=406e3d26&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports